import React__default from 'react';

const PodNamesWithErrorsContext = React__default.createContext(
  /* @__PURE__ */ new Set()
);

export { PodNamesWithErrorsContext };
//# sourceMappingURL=PodNamesWithErrors.esm.js.map
